import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import '../styles/home.css';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import Seo from '../components/Seo';

export default function Home() {
  const [activeTab, setActiveTab] = useState('nonmedis');
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const snap = await getDocs(
          query(collection(db, 'testimonials'), orderBy('createdAt', 'desc'), limit(6))
        );
        setTestimonials(snap.docs.map(docItem => ({ id: docItem.id, ...docItem.data() })));
      } catch (err) {
        console.error('gagal ambil testimoni', err);
      }
    };
    fetchTestimonials();
  }, []);

  const keluhanNonMedis = [
    "Sulit Tidur", "Mimpi Buruk", "Sering Emosi", "Pundak Berat", "Kesemutan", "Sulit Jodoh", "Sering Lupa Rakaat Sholat",
    "Masalah Rumah", "Sering Kesurupan", 
    "Gangguan Jiwa"
  ];

  const keluhanMedis = [
    "Asam Lambung", "Magh", "Vertigo", "Asam Urat", "Insomnia",
    "Asma", "Darah Tinggi", "Rematik", "Kolesterol, dll"
  ];

  return (
    <div>
      <Seo
        title="Ruqyah Syar'i Tegal"
        description="Layanan ruqyah syar'i nasional, konsultasi islami, dan edukasi kesehatan ruhani sesuai Al-Qur'an & Sunnah."
        canonical="/"
        image="https://images.unsplash.com/photo-1524492412937-b28074a5d7da?auto=format&fit=crop&w=1600&q=80"
      />
      <Navbar />

      {/* Hero Section */}
      <section
        className="hero-section"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1524492412937-b28074a5d7da?auto=format&fit=crop&w=1920&q=80')`,
        }}
      >
        <div className="hero-overlay"></div>
        <div className="container hero-content">
          <span className="hero-badge">
            <i className="bi bi-moon-stars"></i>
            Ruqyah Syar&apos;i Tegal
          </span>
          <h1 className="hero-title">Temukan Ketenangan Lewat Ruqyah Syar&apos;i</h1>
          <p className="hero-subtitle">
            Metode Islami untuk membantu gangguan batin, sihir, atau jin, tanpa kesyirikan,
            hanya dengan Al-Qur&apos;an & Sunnah.
          </p>
          <div className="hero-actions">
            <a
              href="https://wa.me/62881011977443"
              className="btn btn-success btn-lg shadow"
              target="_blank"
              rel="noreferrer"
            >
              Konsultasi Sekarang
            </a>
            <a href="#tentang" className="btn btn-outline-light btn-lg shadow">
              Pelajari Ruqyah
            </a>
          </div>
          <div className="hero-highlights">
            <div className="hero-highlight">
              <i className="bi bi-shield-check"></i>
              <div>
                <h6>Syar&apos;i & Aman</h6>
                <p>Tanpa jimat, tanpa syirik.</p>
              </div>
            </div>
            <div className="hero-highlight">
              <i className="bi bi-heart-pulse"></i>
              <div>
                <h6>Menyejukkan Jiwa</h6>
                <p>Pendekatan lembut & menenangkan.</p>
              </div>
            </div>
            <div className="hero-highlight">
              <i className="bi bi-geo-alt"></i>
              <div>
                <h6>Tegal & Sekitarnya</h6>
                <p>Melayani konsultasi lokal.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Apa Itu Ruqyah */}
      <section className="section bg-white about-section" id="tentang">
        <div className="container">
          <div className="row align-items-center">
            {/* Text Content */}
            <div className="col-md-6 text-start">
              <h2 className="section-title mb-3">Apa Itu Ruqyah Syar&apos;i?</h2>
              <p className="section-text">
                <strong>Ruqyah Syar&apos;i</strong> adalah metode penyembuhan spiritual dalam Islam yang dilakukan dengan membaca ayat-ayat Al-Qur&apos;an dan doa-doa dari Nabi Muhammad SAW, tanpa campur tangan unsur mistis atau kesyirikan.
              </p>
              <div className="mt-4">
                <div className="d-flex align-items-start mb-3">
                  <span className="me-3 display-6 text-green">🛡️</span>
                  <div>
                    <h6 className="fw-bold mb-1">Perlindungan dari Gangguan Spiritual</h6>
                    <p className="mb-0 text-muted">Mengusir gangguan jin, sihir, dan energi negatif dengan ayat-ayat Al-Qur&apos;an.</p>
                  </div>
                </div>
                <div className="d-flex align-items-start mb-3">
                  <span className="me-3 display-6 text-green">🧘‍♀️</span>
                  <div>
                    <h6 className="fw-bold mb-1">Ketenangan Batin & Pikiran</h6>
                    <p className="mb-0 text-muted">Menenangkan hati dari was-was, kecemasan, dan gangguan emosional lainnya.</p>
                  </div>
                </div>
                <div className="d-flex align-items-start">
                  <span className="me-3 display-6 text-green">🌙</span>
                  <div>
                    <h6 className="fw-bold mb-1">Meningkatkan Keimanan</h6>
                    <p className="mb-0 text-muted">Mendekatkan diri kepada Allah dengan dzikir dan bacaan Al-Qur&apos;an yang rutin.</p>
                  </div>
                </div>
              </div>
              <a href="https://wa.me/62881011977443" className="btn btn-success mt-4">
                Konsultasikan Keluhan Anda
              </a>
            </div>

            {/* Image */}
            <div className="col-md-6 text-center mt-4 mt-md-0">
              <img
                src="https://images.unsplash.com/photo-1542816417-0983c9c9ad53?auto=format&fit=crop&w=900&q=80"
                alt="Suasana masjid yang tenang"
                loading="lazy"
                className="img-fluid rounded shadow-sm about-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Keluhan Section */}
      <section id="keluhan" className="bg-light py-5 keluhan-section">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-5">
              <h2 className="section-title text-start">Keluhan yang Bisa Ditangani</h2>
              <p className="section-text text-start">
                Banyak orang mengalami keluhan yang tak kunjung sembuh meski sudah berobat medis.
                Dengan <strong>ikhtiar Ruqyah Syar&apos;i</strong>, insya Allah bisa menjadi solusi
                yang menenangkan dan menyejukkan.
              </p>
              <div className="d-flex gap-2 flex-wrap mt-4">
                <button
                  className={`btn ${activeTab === 'nonmedis' ? 'btn-success' : 'btn-outline-success'}`}
                  onClick={() => setActiveTab('nonmedis')}
                >
                  🧿 Non-Medis
                </button>
                <button
                  className={`btn ${activeTab === 'medis' ? 'btn-success' : 'btn-outline-success'}`}
                  onClick={() => setActiveTab('medis')}
                >
                  🌿 Medis Ringan
                </button>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="keluhan-card">
                <div className="row row-cols-2 row-cols-md-3 g-3">
                  {(activeTab === 'nonmedis' ? keluhanNonMedis : keluhanMedis).map((item, i) => (
                    <div key={i} className="col">
                      <div className="border rounded p-2 d-flex align-items-center gap-2">
                        <span>{activeTab === 'nonmedis' ? "🟢" : "✅"}</span>
                        <span>{item}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hadits Section */}
      <section className="section bg-white text-center hadits-section">
        <div className="container">
          <div className="hadits-card">
            <span className="hadits-badge">
              <i className="bi bi-book-half"></i>
              Hadits Shahih
            </span>
            <h2 className="section-title mb-3">Hadits tentang Ruqyah</h2>
            <p className="arabic-text mb-3">
              مَنْ تَسْتَعَاذَى فَأَعِيذُوهُ، وَمَنْ سَأَلَكُمْ بِاللَّهِ فَأَعْطُوهُ، وَمَنْ دَعَاكُمْ فَأَجِيبُوهُ
            </p>
            <p className="latin-text mb-3">
              "Barangsiapa meminta perlindungan kepada kalian dengan menyebut nama Allah, maka lindungilah ia."
            </p>
            <p className="hadits-source">— HR. Muslim no. 1725</p>
          </div>
        </div>
      </section>


      {/* Metode Kami */}
      <section className="section bg-soft-green text-center method-section">
        <div className="container">
          <h2 className="section-title">Bagaimana Kami Membantu Anda?</h2>
          <p className="section-text centered mb-5">
            Semua terapi dilakukan dengan pendekatan syar&apos;i yang aman, tenang, dan menyejukkan.
          </p>

          <div className="row justify-content-center g-4">
            {[
              {
                icon: 'bi-book',
                title: 'Bacaan Al-Qur&apos;an & Sunnah',
                desc: 'Ruqyah dilakukan dengan ayat dan doa yang shahih, sesuai tuntunan Rasul.'
              },
              {
                icon: 'bi-droplet',
                title: 'Media Sunnah yang Berkah',
                desc: 'Air ruqyah, daun bidara, dan minyak zaitun sebagai ikhtiar yang dianjurkan.'
              },
              {
                icon: 'bi-shield-check',
                title: 'Tanpa Syirik & Jimat',
                desc: 'Tidak ada mantra, perdukunan, atau hal mistis. Murni ruqyah syar&apos;i.'
              }
            ].map((item, i) => (
              <div className="col-md-4" key={i}>
                <div className="method-card h-100 text-center shadow-sm">
                  <div className="method-icon">
                    <i className={`bi ${item.icon}`}></i>
                  </div>
                  <h5 className="fw-bold text-green">{item.title}</h5>
                  <p className="text-muted mt-2">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="trust-grid mt-5">
            {[
              { icon: 'bi-check-circle', title: 'Pendampingan Sabar', desc: 'Dibimbing dengan adab, sabar, dan empati.' },
              { icon: 'bi-hand-thumbs-up', title: 'Proses Transparan', desc: 'Setiap tahapan dijelaskan dengan jelas.' },
              { icon: 'bi-people', title: 'Ruang Konsultasi Nyaman', desc: 'Privasi dan kenyamanan pasien dijaga.' },
              { icon: 'bi-stars', title: 'Fokus Ibadah', desc: 'Menguatkan dzikir, shalat, dan tauhid.' }
            ].map((item, i) => (
              <div className="trust-card" key={i}>
                <i className={`bi ${item.icon}`}></i>
                <div>
                  <h6>{item.title}</h6>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Testimoni (Baru) */}
      <section className="section bg-white text-center testimonial-section">
        <div className="container">
          <div className="section-head center">
            <span className="section-eyebrow">Testimoni Pasien</span>
            <h2 className="section-title">Yang Mereka Rasakan</h2>
            <p className="section-text">
              Kesaksian nyata dari mereka yang merasakan ketenangan setelah ruqyah syar&apos;i.
            </p>
          </div>
          {testimonials.length === 0 ? (
            <p className="text-muted">Belum ada testimoni terbaru.</p>
          ) : (
            <div className="row justify-content-center g-4">
              {testimonials.map(item => (
                <div className="col-md-4" key={item.id}>
                  <div className="testimonial-card shadow-sm">
                    <p className="testimonial-quote">"{item.quote}"</p>
                    <p className="testimonial-author">— {item.author}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Lokasi */}
      <section className="section bg-soft-green text-center location-section">
        <div className="container">
          <div className="section-head center">
            <span className="section-eyebrow">Lokasi Ruqyah</span>
            <h2 className="section-title">Mudah Dijangkau</h2>
            <p className="section-text">
              Datang langsung ke lokasi kami untuk konsultasi dan terapi ruqyah syar&apos;i.
            </p>
          </div>
          <div className="map-card">
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3955.250813715102!2d109.1688606!3d-6.9370032!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e6fb9b8900f3a71%3A0x493e311e0ecb0522!2sRuqyah%20Syar'i%20Kab.%20Tegal!5e0!3m2!1sid!2sid!4v1718800000000!5m2!1sid!2sid"
                width="100%"
                height="350"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Lokasi Ruqyah"
              ></iframe>
            </div>
            <div className="location-details">
              <div>
                <h6>Alamat</h6>
                <p>Ruqyah Syar&apos;i Kab. Tegal, Jawa Tengah.</p>
              </div>
              <div>
                <h6>Jam Layanan</h6>
                <p>Setiap hari, 08.00 - 20.00 WIB (dengan janji).</p>
              </div>
              <div>
                <h6>Kontak</h6>
                <p>WhatsApp: +62 881-0119-77443</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ulasan */}
      <section className="section bg-soft-green text-center ulasan-section">
        <div className="container">
          <h2 className="section-title">Ulasan dari Anda</h2>
          <p className="section-text mx-auto mb-4">
            Pernah menjalani ruqyah di tempat kami? Bagikan pengalaman Anda agar bisa membantu yang lain!
          </p>
          <a
            href="https://www.google.com/maps/place/Ruqyah+Syar'i+Kab.+Tegal"
            target="_blank"
            rel="noreferrer"
            className="btn btn-outline-success btn-lg shadow-sm"
          >
            Tulis Ulasan di Google
          </a>
        </div>
      </section>

      <a
  href="https://wa.me/62881011977443"
  target="_blank"
  rel="noreferrer"
  className="whatsapp-float"
  aria-label="WhatsApp Chat"
>
  <i className="bi bi-whatsapp" style={{ fontSize: '2rem', color: 'white' }}></i>
</a>

    </div>
  );
}
